var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-applied-filter-count-mobile.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<span class=\"dom-applied-filter-count\">";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"totalSelectedFacets") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isSortSelected")) {
var t_1;
t_1 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isSortSelected")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"totalSelectedFacets") + 1:runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"totalSelectedFacets"));
frame.set("categoryFacetsAppliedCount", t_1, true);
if(frame.topLevel) {
context.setVariable("categoryFacetsAppliedCount", t_1);
}
if(frame.topLevel) {
context.addExport("categoryFacetsAppliedCount", t_1);
}
output += "\n\n    ";
output += runtime.suppressValue((lineno = 7, colno = 6, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_facets-applied-count",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "categoryFacetsAppliedCount")]})])), env.opts.autoescape);
;
}
output += "</span>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-applied-filter-count-mobile.j2"] , dependencies)